import { CityIcon } from './CityIcon';

/**
 * author: Google
 * id 5A5AC571-1818-45D0-8259-A9177DBED615
 * name city
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/city.svg
 * tags
 * - Places 
 */
export const LocationCityIcon = CityIcon;
export default LocationCityIcon